import ManualSlider from "./ManualSlider";

export default ManualSlider;
